module.exports = __webpack_public_path__ + "static/media/export.1b7a0fdc.svg";